window.__bodhiGallery='loaded';
(function(){
  /* 8 lifestyle photos pinned to fixed slots (your media order). Big tiles = product shots, swap by colour. */
  var LIFE=['7174','15051','1189','6955','1567','6907','1229','Meditation'];
  var SLOT=[0,1,3,4,5,6,8,9];
  var PB='White_BG';     /* Black product  -> big top when Black  */
  var PN='Studio-1472';  /* Natural product-> big top when Natural */
  function grid(){return document.querySelector('.media-gallery__grid');}
  function isNat(){var r=document.querySelector('input[type=radio]:checked');return !!(r&&/natural/i.test(r.value));}
  function shape(s,k){
    if(k<2){s.setProperty('grid-column','1','important');s.setProperty('grid-row','auto','important');s.setProperty('aspect-ratio','1 / 1','important');s.removeProperty('height');}
    else if(k===2){s.setProperty('grid-column','2','important');s.setProperty('grid-row','span 2','important');s.setProperty('aspect-ratio','auto','important');s.setProperty('height','100%','important');}
    else{s.setProperty('grid-column','1 / -1','important');s.setProperty('grid-row','auto','important');s.setProperty('aspect-ratio','3 / 2','important');s.removeProperty('height');}
  }
  function place(){
    try{
      var g=grid();if(!g)return;
      var nat=isNat(),lis=g.children;
      for(var n=0;n<lis.length;n++){
        var li=lis[n],im=li.querySelector('img');if(!im)continue;
        var src=im.src,slot=-1;
        if(src.indexOf(PB)>-1)slot=nat?7:2;
        else if(src.indexOf(PN)>-1)slot=nat?2:7;
        else{for(var i=0;i<LIFE.length;i++){if(src.indexOf(LIFE[i])>-1){slot=SLOT[i];break;}}}
        if(slot<0)continue;
        li.style.setProperty('order',String(slot),'important');
        shape(li.style,slot%5);
      }
      window.__bodhiGallery='ran:'+(nat?'natural':'black');
    }catch(e){window.__bodhiGallery='error:'+e;}
  }
  function burst(){[0,120,300,600,1000,1600,2400].forEach(function(d){setTimeout(place,d);});}
  function init(){
    burst();setInterval(place,300);
    var host=document.getElementById('MainContent')||document.body;
    if(host&&window.MutationObserver){new MutationObserver(place).observe(host,{childList:true,subtree:true});}
    document.addEventListener('change',function(e){if(e.target&&e.target.type==='radio')burst();});
    document.addEventListener('click',function(e){var t=e.target;if(t&&t.closest&&t.closest('label,.variant-picker,variant-picker,fieldset'))burst();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
